/**
 * Shared HTML sanitization utility for landing page components
 * Sanitizes HTML to only allow safe formatting tags
 */

const ALLOWED_TAGS = ["strong", "b", "em", "i", "u", "br"];

/**
 * Creates safe HTML markup by sanitizing input HTML
 * Only allows safe formatting tags (strong, b, em, i, u, br)
 * 
 * @param html - HTML string to sanitize
 * @returns Object with __html property for dangerouslySetInnerHTML
 */
export const createMarkup = (html: string | undefined): { __html: string } => {
  if (!html || typeof html !== "string") {
    return { __html: "" };
  }

  // Simple sanitization - only keep allowed tags
  let sanitizedHtml = html;
  ALLOWED_TAGS.forEach((tag) => {
    const regex = new RegExp(`<${tag}[^>]*>`, "gi");
    sanitizedHtml = sanitizedHtml.replace(regex, `<${tag}>`);
  });

  return { __html: sanitizedHtml };
};

